import { Box } from '@mui/material';
import { ITraininRegistrationProps } from 'views/lms/student/Registration';
import { TrainingRatingView } from 'views/lms/student/TrainingRatingView/TrainingRatingView';

///////////////////////////////////////////////////////////////////////////////

export const RegistrationOpinionView = ({ training }: ITraininRegistrationProps) => {
    return training == null
        ? null
        : (
            <Box height="100%">
                <TrainingRatingView
                    trainingId={training.trainingId}
                />
            </Box>
        );
};
